import React from 'react';
import { Link } from 'react-router-dom';
import { ENTREPRISE } from '../data/site';

export default function BarreMobile() {
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 border-t-4 border-jaune">
      <a
        href={ENTREPRISE.telephoneLien}
        className="bg-nuit text-white font-cond uppercase font-bold tracking-[0.06em] py-4 text-center"
      >
        Appeler
      </a>
      <Link
        to="/contact"
        className="bg-jaune text-nuit font-cond uppercase font-bold tracking-[0.06em] py-4 text-center"
      >
        Mon devis
      </Link>
    </div>
  );
}
